/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type JournalDtoTopic = (typeof JournalDtoTopic)[keyof typeof JournalDtoTopic];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JournalDtoTopic = {
  NONE: 'NONE',
  PERSONAL_DETAILS: 'PERSONAL_DETAILS',
  ANAMNESIS: 'ANAMNESIS',
  DIAGNOSTICS: 'DIAGNOSTICS',
  THERAPY: 'THERAPY',
  CONTACT_TRACING: 'CONTACT_TRACING',
  NETWORK: 'NETWORK',
  TRACING_CONTACT: 'TRACING_CONTACT',
  SCREENING_PERSON: 'SCREENING_PERSON',
} as const;
